export const operationStatusColors = {
    EM_TRANSITO: {
        label: 'em_transito',
        color: 'warning'
    },
    APROVADA: {
        label: 'aprovada',
        color: 'success'
    },
    REPROVADA: {
        label: 'reprovada',
        color: 'danger'
    }
};
